import type { PublicPetitionDocumentRow, PublicPetitionWizardDraft } from '../types/publicPetitionCaseRequest';
import { FILE_CATEGORY_PUBLIC_PETITION } from '../pages/wizard/publicPetition/publicPetitionConstants';
import { isDocumentTypeUuid } from '../utils/documentTypeId';

export const DEFAULT_PUBLIC_PETITION_DRAFT: PublicPetitionWizardDraft = {
  fileCategory: FILE_CATEGORY_PUBLIC_PETITION,
  fileCategoryId: '',
  subFileCategoryId: '',
  subFileCategoryName: '',
  applicableAreas: [],
  applicableAreaIds: [],

  description: '',
  caseMatter: 'CRIMINAL',
  provinceId: '',
  provinceName: '',
  districtId: '',
  districtName: '',
  yourReferenceNumber: '',
  otherExternalReferences: '',
  caseNumber: '',
  hasConnectedMatters: 'no',
  connectedCaseNumber: '',
  connectedAgdFileRefAvailable: false,
  connectedAgdFileRef: '',

  petitionerName: '',
  nicOrIdentificationNumber: '',
  petitionerAddress: '',
  petitionerContactNumber: '',
  petitionerEmail: '',
  representedByAttorney: false,
  attorneyName: '',
  attorneyContactNumber: '',
  respondentNames: '',
  respondentTypeId: '',
  respondentTypeName: '',
  respondentAddress: '',
  numberOfRespondents: '',

  urgencyLevelId: '',
  urgencyLevelName: '',
  deadline: '',
  urgencyJustification: '',

  deliveryMethodIds: [],
  deliveryMethods: [],
  deliveryOther: '',

  documents: [],
  confirmCorrect: false,

  draftRequestId: '',
  referenceNo: '',
};

export type PublicPetitionWizardContextValue = {
  draft: PublicPetitionWizardDraft;
  setDraft: React.Dispatch<React.SetStateAction<PublicPetitionWizardDraft>>;
  reset: () => void;
};

function normalizeDocLabel(name: string): string {
  return name.trim().toLowerCase().replace(/\s+/g, ' ');
}

function findDocumentForChecklistItem(
  prev: PublicPetitionDocumentRow[],
  item: { id: string; documentTypeId: string; name: string; documentTypeCode?: string },
): PublicPetitionDocumentRow | undefined {
  return prev.find((d) => {
    if (d.checklistItemId === item.id) return true;
    if (item.documentTypeId && d.documentTypeId === item.documentTypeId) return true;
    if (item.documentTypeCode) {
      if (d.documentTypeId === item.documentTypeCode || d.checklistItemId === item.documentTypeCode) return true;
    }
    if (!isDocumentTypeUuid(d.documentTypeId) && normalizeDocLabel(d.documentName) === normalizeDocLabel(item.name)) {
      return true;
    }
    return false;
  });
}

export function syncPublicPetitionDocumentsFromChecklist(
  prev: PublicPetitionDocumentRow[],
  checklist: { id: string; documentTypeId: string; name: string; mandatory: boolean; documentTypeCode?: string }[],
): PublicPetitionDocumentRow[] {
  return checklist.map((item) => {
    const existing = findDocumentForChecklistItem(prev, item);
    if (existing) {
      return {
        ...existing,
        checklistItemId: item.id,
        documentTypeId: item.documentTypeId,
        documentName: item.name,
        mandatory: item.mandatory,
      };
    }
    return {
      id: crypto.randomUUID(),
      checklistItemId: item.id,
      documentTypeId: item.documentTypeId,
      documentName: item.name,
      mandatory: item.mandatory,
      fileName: '',
      originalFileName: '',
      uploadTime: '',
      skipReason: '',
    };
  });
}
